import * as React from 'react';
import { Button, MuiBox, Box, Backdrop, Typography, Stack, AbsoluteBox, Grid } from '@kis-technologies/kis-ui';
import { ActionOverlayProps } from './types';
import { useStyles } from './styled';
/**
 * Overlay used for Actions
 */

export const ActionOverlay = (props: ActionOverlayProps) => {
  const {
    title,
    description = '',
    confirmText,
    onConfirm,
    cancelText,
    onCancel,
    height,
    width: propsWidth,
    appearance
  } = props;

  const width = propsWidth || 700;
  const classes = useStyles({ width, height })();

  const onEl = (el: HTMLElement) => {
    const { style } = el;
    style.background = 'rgba(255,255,255,0.9)';
    style.zIndex = '2147483646';
    style.overflowX = 'hidden';
    style.overflowY = 'scroll';
  };

  return (
    <Backdrop onEl={onEl} open>
      <Grid container className={classes.actionOverlayContainer} direction="column">
        {/* Title */}
        <MuiBox className={classes.actionOverlayTitle}>
          {typeof title === 'string' ? (
            <Typography component="h2" align="center" sx={{ lineHeight: 1 }}>
              {title}
            </Typography>
          ) : (
            title
          )}
        </MuiBox>
        {/* Description */}
        <Box flexOverride="none" margin="5 0 7">
          {typeof description === 'string' ? (
            <Typography sx={{ lineHeight: 1 }}>{description}</Typography>
          ) : (
            description
          )}
        </Box>

        {/* Cancel and Confirm Buttons */}
        <AbsoluteBox bottom="-45px">
          <Stack>
            {cancelText && (
              <Button customSize="large" onClick={onCancel} appearance="white" className={classes.actionOverlayButtons}>
                {cancelText}
              </Button>
            )}
            <Button
              customSize="large"
              onClick={onConfirm}
              appearance={appearance ? appearance : 'primary'}
              className={classes.actionOverlayButtons}
            >
              {confirmText}
            </Button>
          </Stack>
        </AbsoluteBox>
      </Grid>
    </Backdrop>
  );
};
